import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGIN_RESET,
  LOGOUT,
  SET_USER,
  INITIALIZE_AUTH,
  LOGIN_MFA_REQUIRED,
  LOGIN_PASSWORD_REQUIRED,
  LOGIN_OTP_REQUIRED,
  LOGIN_RESET_PASSWORD_REQUIRED,
} from '../actions/loginAction';
import { STORAGE_KEYS } from '../../utils/constants';

const initialState = {
  apiState: '',
  message: '',
  data: null,
  error: '',
  user: null,
  token: null,
  refreshToken: null,
  isAuthenticated: false,
  mfaRequired: false,
  mfaSessionToken: null,
  maskedEmail: null,
  mfaExpiryMinutes: null,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        apiState: 'loading',
      };
    case LOGIN_SUCCESS:
      // Store tokens and user data if status is 1
      if (action.response.status === 1 && action.response.data) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, action.response.data.accessToken);
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, action.response.data.refreshToken);
        localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(action.response.data.user));
        if (action.response.data.expiresAt) {
          localStorage.setItem('expiresAt', action.response.data.expiresAt);
        }
        if (action.response.data.permissions) {
          localStorage.setItem(STORAGE_KEYS.PERMISSIONS, JSON.stringify(action.response.data.permissions));
        }
      }
      return {
        ...state,
        apiState: 'success',
        data: action.response.data || action.response,
        user: action.response.data?.user || null,
        token: action.response.data?.accessToken || null,
        refreshToken: action.response.data?.refreshToken || null,
        isAuthenticated: true,
        message: action.response.message || 'success',
        error: '',
      };
    case LOGIN_MFA_REQUIRED:
      return {
        ...state,
        apiState: 'mfa_required',
        data: action.response.data || action.response,
        message: action.response.message || 'Sign-in link sent',
        mfaRequired: true,
        mfaSessionToken: action.response.data?.mfaSessionToken || null,
        maskedEmail: action.response.data?.maskedEmail || null,
        mfaExpiryMinutes: action.response.data?.expiryMinutes || null,
        isAuthenticated: false,
        error: '',
      };
    case LOGIN_PASSWORD_REQUIRED:
      return {
        ...state,
        apiState: 'password_required',
        data: action.response.data || action.response,
        message: action.response.message || 'Password required',
        isAuthenticated: false,
        error: '',
      };
    case LOGIN_OTP_REQUIRED:
      return {
        ...state,
        apiState: 'otp_required',
        data: action.response.data || action.response,
        message: action.response.message || 'Verification code sent',
        mfaRequired: true,
        mfaSessionToken: action.response.data?.mfaSessionToken || null,
        maskedEmail: action.response.data?.maskedEmail || null,
        mfaExpiryMinutes: action.response.data?.expiryMinutes || null,
        isAuthenticated: false,
        error: '',
      };
    case LOGIN_RESET_PASSWORD_REQUIRED:
      return {
        ...state,
        apiState: 'reset_password_required',
        data: action.response.data || action.response,
        message: action.response.message || 'Password reset required',
        isAuthenticated: false,
        error: '',
      };
    case LOGIN_FAIL:
      return {
        ...state,
        apiState: 'error',
        data: action.response,
        error: action.response.errors || null,
        message: action.response.message || 'error',
        isAuthenticated: false,
      };
    case LOGIN_RESET:
      return initialState;
    case LOGOUT:
      return {
        ...initialState,
        apiState: '',
      };
    case SET_USER:
      return {
        ...state,
        user: action.user,
      };
    case INITIALIZE_AUTH:
      const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      const userData = localStorage.getItem(STORAGE_KEYS.USER_DATA);
      if (token && userData) {
        return {
          ...state,
          token,
          user: JSON.parse(userData),
          isAuthenticated: true,
        };
      }
      return state;
    default:
      return state;
  }
};

export default loginReducer;

